<template>
  <div class="wrap">
    <div class="content">
      <div class="container">
        <div class="row state-login">
          <div class="col-xs-12">
            <h2>Login</h2>
            <div class="form-group">
              <label>Shop identifier</label>
              <input type="text" class="login-shopid form-control" v-model="shopId" />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input type="email" class="login-email form-control" v-model="email" />
            </div>
            <div class="form-group">
              <label>Password</label>
              <input type="password" class="login-password form-control" v-model="password" />
            </div>
            <div class="error" v-if="error">
      
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container transparent footer-container">
      <button class="footer-button-fullwidth btn btn-success login-submit" v-on:click="loginClicked">Login</button>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      shopId: this.defaultShopId ? this.defaultShopId : '',
      email: '',
      password: '',
    }
  },
  computed: {
    ...mapGetters([
      'loginFailed',
      'defaultShopId',
      'apiKey'
    ]),
    error () {
      return ''
    }
  },
  methods: {
    ...mapActions([
      'login',
      'logout'
    ]),
    loginClicked: function () {
      let $this = this
      this.login({ 
        shopId: this.shopId.toLowerCase(),
        email: this.email,
        password: this.password
      }).then(() => {
        $this.$router.push('/')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Login.vue